import { BED_SLOTS_DEFAULT, MAX_BEDS_DEFAULT } from "../config/app.constant";

export class FacilityModel {
  facilityId = '';
  facilityName = '';
  facilityPhone? = '';
  facilityEmail? = '';
  facilityRepresentativeName? = '';
  facilityResponseTitle? = '';
  corporateId? = '1';
  timeZone = 'US/Central';
  isDisabled = false;
  enableCaspar = false;
  enablePCC = false;
  enableEtectRx = false;
  pccOffMaxmBedSlotPerRoom = MAX_BEDS_DEFAULT;
  pccOffBedSlot = BED_SLOTS_DEFAULT;
  pccOffBedSlotName? = '';
}
